import React from 'react';
import { View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { OPComponent, I18n, HeaderButton, SwipableList } from '../components';

export default class MedicalTeamList extends OPComponent {
  constructor(props) {
    super(props);
  }

  keyExtractor = item => {
    return `${item.medicalTeamId}`;
  };

  formatData = data => {
    return data.map(item => {
      let subLabel = `${item.providerType}`;
      if (item.phone) subLabel += `\n${item.phone}`;
      if (item.email) subLabel += `\n${item.email}`;

      return {
        item,
        label: item.providerName,
        subLabel,
      };
    });
  };

  render() {
    const props = this.props;

    return (
      <View style={props.listContainerStyle || THEME.container}>
        <HeaderButton
          label={props.headerLabel || I18n.t('medicalTeam.primaryTeam')}
          subLabel={I18n.ac('medicalTeam.addMedicalTeam')}
          onPress={props.onAdd}
          disabled={!props.onAdd}
          containerStyle={props.headerContainerStyle}
          labelStyle={props.headerLabelStyle}
        />
        <SwipableList
          data={this.formatData(props.medicalTeam)}
          keyExtractor={this.keyExtractor}
          onSelect={props.onSelect}
          onRemove={props.onRemove}
          swipeDisabled={!props.onRemove}
          scrollable={this.props.scrollable}
        />
      </View>
    );
  }
}
